import { types, Instance } from 'mobx-state-tree';
const { model, string, identifier, maybe, maybeNull, number } = types;

export const GroupModel = model('GroupModel', {
  dn: identifier,
  uid: maybe(string),
  sn: string,
  givenname: maybe(string),
  mail: maybe(string),
  syncGroup: maybeNull(string),
  userCount: maybeNull(string),
});
export type IGroupModel = Instance<typeof GroupModel>;

export const ManagerModel = model('ManagerModel', {
  user_id: number,
  secondName: maybe(string),
  firstName: maybe(string),
  email: maybe(string),
});
export type IManagerModel = Instance<typeof ManagerModel>;
